import { OrderStatusType } from '@/@types/order';
import { OrderProcessType } from '@/assets/data/orderList';
import styled from 'styled-components';

interface Props {
  orderProcess: OrderProcessType[];
  orderStatus: OrderStatusType;
}
const OrderProcess = ({ orderProcess, orderStatus }: Props) => {
  const focusedIndex = orderProcess.findIndex(process =>
    process.statuses.includes(orderStatus)
  );

  return (
    <Wrapper>
      <ProcessWrapper>
        {orderProcess.map((_, key) => (
          <Process key={key}>
            <Circle isFocus={key <= focusedIndex}>{key + 1}</Circle>
            {key + 1 !== orderProcess.length && (
              <Bar isFocus={key < focusedIndex} />
            )}
          </Process>
        ))}
      </ProcessWrapper>
      <ProcessLabelWrapper>
        {orderProcess.map((process, key) => (
          <ProcessLabel
            key={`process_label_${key}`}
            isFocus={key <= focusedIndex}>
            {process.label}
          </ProcessLabel>
        ))}
      </ProcessLabelWrapper>
    </Wrapper>
  );
};

export default OrderProcess;

const Wrapper = styled.div`
  margin-bottom: 40px;
`;

const ProcessWrapper = styled.div`
  display: flex;
  padding: 0 10px;
`;

const Process = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  align-items: flex-start;

  &:last-child {
    flex: 0;
  }
`;

const Circle = styled.div<{ isFocus: boolean }>`
  display: flex;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  max-width: 32px;
  height: 32px;
  margin-bottom: 8px;

  ${({ theme, isFocus }) => `
    ${theme.DF_TYPOGRAPHY.UI17M};
    color: ${theme.DF_COLOR.WHITE};
    background: ${isFocus ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.GRAY100};
  `};
`;

const Bar = styled.div<{ isFocus: boolean }>`
  width: 100%;
  height: 2px;
  margin-top: 16px;

  ${({ theme, isFocus }) => `
    background: ${isFocus ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.GRAY100};
  `};
`;

const ProcessLabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ProcessLabel = styled.div<{ isFocus: boolean }>`
  ${({ theme, isFocus }) => `
    ${theme.DF_TYPOGRAPHY.UI15M};
    color: ${isFocus ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.GRAY400};
  `};
`;
